import React from "react"
import { Paper, withStyles, Typography } from "@material-ui/core"
import { graphql, useStaticQuery } from "gatsby"
import { moment, parseDate } from "../../helpers/moment"

const query = graphql`
    query {
        pageText {
            date {
                early_bird
            }
        }
    }
`

const styles = (theme) => ({
        container: {
            position: "sticky",
            bottom: 0,
            right: 0,

            display: "flex",
            flexDirection: "row-reverse",
        },
        paper: {
            marginRight: theme.spacing(4),
            marginLeft: theme.spacing(4),
            marginBottom: theme.spacing(4),
            padding: theme.spacing(3),

        },
    }
)

const DisruptorMd_ = ({ classes, children }) => {
    const data = useStaticQuery(query)
    const date = parseDate(data.pageText.date.early_bird)
    const today = parseDate(moment().format("DD/MM/YYYY"))

    return date.diff(today, "days") < 0 ? null : <div className={classes.container}>
        <Paper elevation={12} className={classes.paper}>
            <Typography align={"justify"} children={children}/>
        </Paper>
    </div>
}

export const DisruptorMd = withStyles(styles)(DisruptorMd_)